export default __webpack_public_path__ + "static/media/video_slide1.74075c86.jpg";